import axiosInstance from "../API/axiosInstance";

export const createBreakout = async (sessionId, timeLimitMinutes) => {
    const { data } = await axiosInstance.post(`/sessions/${sessionId}/breakouts`, {
        timeLimitMinutes,
    });
    return data;
};

export const inviteToBreakout = async (breakoutId, inviteeIds) => {
    const { data } = await axiosInstance.post(`/breakouts/${breakoutId}/invite`, {
        inviteeIds,
    });
    return data;
};

export const respondToBreakoutInvite = async (breakoutId, accepted) => {
    const { data } = await axiosInstance.post(`/breakouts/${breakoutId}/respond`, {
        accepted,
    });
    return data;
};

export const rejoinBreakout = async (breakoutId) => {
    const { data } = await axiosInstance.post(`/breakouts/${breakoutId}/join`);
    return data;
};

export const leaveBreakout = async (breakoutId) => {
    const { data } = await axiosInstance.post(`/breakouts/${breakoutId}/leave`);
    return data;
};

export const endBreakout = async (breakoutId) => {
    const { data } = await axiosInstance.post(`/breakouts/${breakoutId}/end`);
    return data;
};

export const getBreakoutStatus = async (breakoutId) => {
    const { data } = await axiosInstance.get(`/breakouts/${breakoutId}/status`);
    return data;
};

export const getMyActiveBreakout = async (sessionId) => {
    const { data } = await axiosInstance.get(`/sessions/${sessionId}/breakouts/my`);
    return data;
};
